import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { DatePipe } from '@angular/common';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { EnumIdsTcIdioma, EnumIdsTcPais, Tc, TcExpanded, TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { TCampaniaEspecificaViewModel } from '../../../_mantenimiento/campanias/campaniasespecificas/campaniaespecifica.types';
import { PeriodoCamViewModel } from '../../../_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';
import { PuntoInspeccionService } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';
import { TClaveSolicitudAtestFitoViewModel } from '../../atestaciones/datosbasicos/datosbasicosAtestFito.types';
import { EnumIdsTcEstadoSolicitudAtestFito } from '../../atestaciones/types/enum';
import { BuscadorSolicitudExService } from '../../buscadores/solicitudes/buscador-solicitudEx.service';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { ParametrosNuevaSolicitudExViewModel, SolicitudExViewModel } from '../datosbasicos/datosbasicosEx.types';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { EnumIdsTcFormatoSolicitud } from '../../../_importacion/solicitudes/types/enum';

@Component({
    selector: 'app-tiposolicitudex-list',
    templateUrl: './tiposolicitudEx-list.component.html',
})
export class TipoSolicitudExListComponent extends ComponentBase implements OnInit {
    listTipoSolicitudEx: TcExpanded[];
    listPais: Tc[];
    listIdioma: Tc[];
    listPuntoInspeccion: Tc[];
    listUbicacion: Tc[];
    listInstalacionAutorizada: Tc[];
    listCampania: TCampaniaEspecificaViewModel[];
    listPeriodo: PeriodoCamViewModel[];

    isCollapsedTipos = false;
    isCollapsedDatosTercerPais = false;
    isCollapsedAnulacionSustitucion = false;
    isCollapsedAtestacionFitosanitaria = false;

    IdProvincia: number | null;
    IdPaisDestino: number;
    AvisoConfeccionPeriodo = false;
    IdIdioma: number;
    campoUbicacion = true;
    campoInstalacion = true;
    solicitudEx: SolicitudExViewModel;
    validacionCollection: string[] = [];
    atestFitoCollection: TClaveSolicitudAtestFitoViewModel[];
    mensajeExito1 = '';
    mensajeExito2 = '';
    NumeroCertificado = '';
    colsAtestaciones: any[];
    numeroAtestaciones = 0;
    mensajeAtestacion = '';

    mostrarAtestacionesFitosanitarias = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private puntoInspeccionService: PuntoInspeccionService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private solicitudExService: SolicitudExService,
        private confirmationService: ConfirmationService,
        private buscadorsolicitudExService: BuscadorSolicitudExService,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        let params = new HttpParams();

        params = params.append('idpais', EnumIdsTcPais.ID_ESPANA.toString());
        params = params.append('esgrabador', this.isGrabador.toString());
        params = params.append('idusuario', this.loggedInUser!.Id.toString());

        this.globalService.getAllPaisesSinSpain().subscribe(res => {
            this.listPais = res;
        });

        // Devuelve la lista de tipos de solicitud activos
        this.globalService.getTipoSolicitudExporActivos().subscribe(res => {
            this.listTipoSolicitudEx = res;
        });

        //Todo:agaro. 12042022. Particularizamos por los pifs habilitados para exportación
        //this.listPuntoInspeccion$ = this.globalService.getPuntoInspeccionNuevaSolicitud(params);
        this.globalService.getPuntoInspeccionNuevaSolicitudExportacion(params).subscribe(res => {
            this.listPuntoInspeccion = res;
        });

        this.globalService.getIdioma().subscribe(res => {
            this.listIdioma = res;
        });

        this.createForm();

        this.atestFitoCollection = [];

        this.colsAtestaciones = [
            { field: 'Link', header: '' },
            { field: 'RefAtestFito', header: 'Referencia Atestación' },
            { field: 'Pin', header: 'PIN' },
        ];
    }

    createForm() {
        this.form = this.fb.group({
            tipoSolicitudEx: 'T',
            IdPuntoInspeccion: [null, Validators.required],
            IdPaisDestino: [null, Validators.required],
            IdIdioma: [null, Validators.required],
            IdUbicacion: [null, Validators.required],
            IdInstalacionAutorizada: [null, Validators.required],
            esPrevia: false,
            esAtestacionFitosanitaria: false,
            CodigoSolicitud: '',
            NumeroCertificado: '',
            RefAtestFito: '',
            Pin: '',
            IdCampania: [null],
            IdPeriodo: [null],
        });
    }

    onSelectedTipoSolicitudEx(codigo?: string) {
        if (codigo !== '') {
            this.form.patchValue({
                tipoSolicitudEx: codigo,
                esAtestacionFitosanitaria: false,
            });
            this.mostrarAtestacionesFitosanitarias = false;
            this.atestFitoCollection = [];
            this.numeroAtestaciones = this.atestFitoCollection?.length;
            this.form.controls['IdPaisDestino'].enable();
        }

        this.resetFormValues();

        //this.addValidator("IdPuntoInspeccion", Validators.required);
        //this.form.controls["IdPuntoInspeccion"].enable();

        switch (this.form.controls['tipoSolicitudEx'].value) {
            case 'T':
                //Volvemos a cargar los países, sin España que solo va en Canarias y Reexportación
                this.globalService.getAllPaisesSinSpain().subscribe(res => {
                    this.listPais = res;
                });
                this.addValidator('IdPuntoInspeccion', Validators.required);
                this.addValidator('IdPaisDestino', Validators.required);
                this.addValidator('IdIdioma', Validators.required);
                this.addValidator('IdUbicacion', Validators.required);
                this.addValidator('IdInstalacionAutorizada', Validators.required);
                this.removeValidators('IdCampania');
                this.removeValidators('IdPeriodo');
                this.removeValidators('CodigoSolicitud');
                this.removeValidators('NumeroCertificado');

                break;
            case 'R':
                //Volvemos a cargar los países, ahora con España, RDLF 120325 (tarea 166624)
                this.globalService.getAllPaisesExpor().subscribe(res => {
                    this.listPais = res;
                });
                this.addValidator('IdPuntoInspeccion', Validators.required);
                this.addValidator('IdPaisDestino', Validators.required);
                this.addValidator('IdIdioma', Validators.required);
                this.addValidator('IdUbicacion', Validators.required);
                this.addValidator('IdInstalacionAutorizada', Validators.required);
                this.removeValidators('IdCampania');
                this.removeValidators('IdPeriodo');
                this.removeValidators('CodigoSolicitud');
                this.removeValidators('NumeroCertificado');

                this.campoInstalacion = false;
                this.form.controls['IdInstalacionAutorizada'].disable();
                this.form.controls['esPrevia'].disable();
                break;
            case 'C':
                this.globalService.getAllPaises().subscribe(res => {
                    this.listPais = res;
                });

                this.addValidator('IdPuntoInspeccion', Validators.required);
                this.addValidator('IdPaisDestino', Validators.required);
                this.addValidator('IdIdioma', Validators.required);
                this.addValidator('IdUbicacion', Validators.required);
                this.addValidator('IdInstalacionAutorizada', Validators.required);
                this.removeValidators('IdCampania');
                this.removeValidators('IdPeriodo');
                this.removeValidators('CodigoSolicitud');
                this.removeValidators('NumeroCertificado');

                this.form.controls['IdPaisDestino'].disable();
                this.form.controls['IdIdioma'].disable();
                this.form.controls['esPrevia'].disable();
                //this.form.controls['esAtestacionFitosanitaria'].disable();

                //Precargamos el idioma y el país de destino y se dejan no editables
                this.form.patchValue({
                    IdPuntoInspeccion: null,
                    esPrevia: false,
                    esAtestacionFitosanitaria: false,
                    IdPaisDestino: EnumIdsTcPais.ID_ESPANA,
                    IdIdioma: EnumIdsTcIdioma.ID_ESPANOL,
                    IdUbicacion: null,
                    IdInstalacionAutorizada: null,
                    CodigoSolicitud: '',
                    NumeroCertificado: '',
                });

                this.IdPaisDestino = EnumIdsTcPais.ID_ESPANA;
                this.IdIdioma = EnumIdsTcIdioma.ID_ESPANOL;

                break;
            case 'AS':
                this.addValidator('CodigoSolicitud', Validators.required);
                this.addValidator('NumeroCertificado', Validators.required);
                this.removeValidators('IdPuntoInspeccion');
                this.removeValidators('IdPaisDestino');
                this.removeValidators('IdIdioma');
                this.removeValidators('IdUbicacion');
                this.removeValidators('IdInstalacionAutorizada');
                this.removeValidators('IdCampania');
                this.removeValidators('IdPeriodo');
                break;
            case 'CE':
                //Volvemos a cargar los países, sin España que solo va en Canarias y Reexportación
                this.globalService.getAllPaisesSinSpain().subscribe(res => {
                    this.listPais = res;
                });
                this.globalService.getCampaniasPeriodosActivos().subscribe(res => {
                    this.listCampania = res;
                });
                this.addValidator('IdPuntoInspeccion', Validators.required);
                this.addValidator('IdPaisDestino', Validators.required);
                this.addValidator('IdIdioma', Validators.required);
                this.addValidator('IdUbicacion', Validators.required);
                this.addValidator('IdCampania', Validators.required);
                this.addValidator('IdPeriodo', Validators.required);
                this.removeValidators('CodigoSolicitud');
                this.removeValidators('NumeroCertificado');

                this.campoInstalacion = false;
                this.form.controls['IdPaisDestino'].disable();
                this.form.controls['IdInstalacionAutorizada'].disable();
                this.form.controls['esPrevia'].disable();
                break;
            default:
                break;
        }
    }

    onSelectPuntoInspeccion() {
        this.form.patchValue({
            IdUbicacion: null,
            IdInstalacionAutorizada: null,
        });
        if (this.form.controls['IdPuntoInspeccion'].value === null) {
            this.listUbicacion = [];
            this.listInstalacionAutorizada = [];
            //return;
        } else {
            const idPuntoInspeccion = this.form.controls['IdPuntoInspeccion'].value;
            let params = new HttpParams();
            params = params.append('id', idPuntoInspeccion.toString());
            params = params.append('esexportacion', 'true');
            this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
                this.listUbicacion = res;
            });

            this.puntoInspeccionService.getPuntoInspeccion(this.form.controls['IdPuntoInspeccion'].value).subscribe(result => {
                this.IdProvincia = result.IdProvincia;
                this.globalService.getInstalacionesAutorizadasByProvincia(this.IdProvincia!).subscribe(res => {
                    this.listInstalacionAutorizada = res;
                });
            });
        }
    }

    onSelectIdioma() {
        this.IdIdioma = this.form.controls['IdIdioma'].value;
    }

    onSelectPaisDestino() {
        this.IdPaisDestino = this.form.controls['IdPaisDestino'].value;
    }

    onSelectUbicacion() {
        //si ubicacion es nulo
        if (this.form.controls['IdUbicacion'].value === null) {
            this.form.controls['IdInstalacionAutorizada'].enable();
            this.addValidator('IdInstalacionAutorizada', Validators.required);
            this.campoInstalacion = true;
        }
        //si no deshabilito la Instalacion
        else {
            this.form.controls['IdInstalacionAutorizada'].disable();
            this.removeValidators('IdInstalacionAutorizada');
            this.campoInstalacion = false;
        }
    }

    onSelectInstalacionAutorizada() {
        //si instalacion es nulo
        if (this.form.controls['IdInstalacionAutorizada'].value === null) {
            this.form.controls['IdUbicacion'].enable();
            this.addValidator('IdUbicacion', Validators.required);
            this.campoUbicacion = true;
        }
        //si no deshabilito la Ubicacion
        else {
            this.form.controls['IdUbicacion'].disable();
            this.removeValidators('IdUbicacion');
            this.campoUbicacion = false;
        }
    }

    onSelectCampania() {
        this.form.patchValue({
            IdPeriodo: null,
            IdPaisDestino: null,
            IdIdioma: null,
        });
        this.form.controls['IdIdioma'].enable();
        if (this.form.controls['IdCampania'].value === null) {
            this.listPeriodo = [];
        } else {
            const idCampania = this.form.controls['IdCampania'].value;
            const seleccionado = this.listCampania.find(x => x.Id === idCampania);
            this.IdPaisDestino = seleccionado!.IdPais!;
            if (seleccionado!.IdIdioma !== null) {
                this.IdIdioma = seleccionado!.IdIdioma!;
                this.form.patchValue({
                    IdPaisDestino: this.IdPaisDestino,
                    IdIdioma: this.IdIdioma,
                });
                this.form.controls['IdIdioma'].disable();
            }
            //Precargamos el idioma y el país de destino y se dejan no editables
            this.form.patchValue({
                IdPaisDestino: this.IdPaisDestino,
            });
            this.form.controls['IdPaisDestino'].disable();

            this.globalService.getPeriodosActivosByIdCampania(idCampania).subscribe(res => {
                this.listPeriodo = res;
            });
        }
    }

    onSelectPeriodo() {
        const idPeriodo = this.form.controls['IdPeriodo'].value;
        const seleccionado = this.listPeriodo?.find(x => x.Id === idPeriodo);
        this.AvisoConfeccionPeriodo = seleccionado!.AvisoConfeccion;
    }

    private resetFormValues() {
        //Volvemos a cargar los países, sin España que solo va en Canarias
        //this.globalService.getAllPaisesSinSpain().subscribe(res => {
        //    this.listPais = res;
        //});

        //jlht Evitamos que al cambiar de tipo de solicitud aparezca, de primeras, en rojo los campos obligatorios a ese tipo de solicitud
        this.submitted = false;

        //hay que reiniciar estas variables para no arrastrar condiciones al cambiar entre tipos de solicitud
        this.solicitudEx = new SolicitudExViewModel();
        this.NumeroCertificado = '';
        this.validacionCollection = [];

        this.listPais = [];

        this.form.patchValue({
            IdPuntoInspeccion: null,
            esPrevia: false,
            esAtestacionFitosanitaria: false,
            IdPaisDestino: null,
            IdIdioma: null,
            IdUbicacion: null,
            IdInstalacionAutorizada: null,
            CodigoSolicitud: '',
            NumeroCertificado: '',
            RefAtestFito: '',
            Pin: '',
            IdCampania: null,
            IdPeriodo: null,
        });

        this.form.controls['IdPaisDestino'].enable();
        this.form.controls['IdIdioma'].enable();
        this.form.controls['IdUbicacion'].enable();
        this.form.controls['IdInstalacionAutorizada'].enable();
        this.form.controls['esPrevia'].enable();
        this.form.controls['esAtestacionFitosanitaria'].enable();

        this.listUbicacion = [];
        this.listInstalacionAutorizada = [];
        this.AvisoConfeccionPeriodo = false;
    }

    onNext() {
        if (this.form.controls['tipoSolicitudEx'].value === 'AS') {
            this.submitted = true;

            if (!this.form.valid) {
                this.addErrorMessage('Debe buscar un Nº Solicitud o Nº Certificado');
                return;
            }

            if (this.solicitudEx?.Id > 0) {
                //SE CLONA
                this.confirmationService.confirm({
                    message: '¿Está seguro de clonar esta solicitud?',
                    accept: () => {
                        let params = new HttpParams();

                        params = params.append('idSolicitudEx', this.solicitudEx.Id.toString());
                        params = params.append('tipoSolicitudEx', EnumIdsTcTipoSolicitudEx.ID_ANULACION_SUSTITUCION.toString());
                        //Actual logic to perform a confirmation
                        this.buscadorsolicitudExService.cloneSolicitud(params).subscribe({
                            next: res => {
                                this.addSuccessMessage('Solicitud clonada correctamente');
                                const idSolicitud = res;
                                this.router.navigate(['/exportacion/solicitud/datosbasicosEx/' + idSolicitud]);
                            },
                            error: error => {
                                this.catchServerError(error);
                            },
                        });
                    },
                });
            } else {
                this.addErrorMessage('Debe buscar un Nº Solicitud o Nº Certificado');
            }
        } else if (
            (this.form.controls['tipoSolicitudEx'].value === 'T' ||
                this.form.controls['tipoSolicitudEx'].value === 'R' ||
                this.form.controls['tipoSolicitudEx'].value === 'C') &&
            this.form.controls['esAtestacionFitosanitaria'].value === true
        ) {
            this.submitted = true;

            if (!this.form.valid) {
                return;
            }
            if (this.numeroAtestaciones === 0) {
                this.addErrorMessage('Debe añadir al menos una Atestación Fitosanitaria al listado');
                return;
            }
            //CREAR LA SOLICITUD EN ESTE MOMENTO PARA PODER ENLAZAR CON LAS ATESTACIONES
            this.onSubmit();
        } else {
            this.submitted = true;

            if (!this.form.valid) {
                return;
            }

            this.WriteParams();

            this.router.navigate(['/exportacion/solicitud/datosbasicosEx/create']);
        }
    }

    onSearchSolicitudAtestFito() {
        if (this.form.controls['RefAtestFito'].value !== '' && this.form.controls['Pin'].value !== '') {
            this.mensajeAtestacion = '';
            this.validacionCollection = [];

            let params = new HttpParams();
            params = params.append('refAtestFito', this.form.controls['RefAtestFito'].value.toString());
            params = params.append('pin', this.form.controls['Pin'].value.toString());

            this.solicitudExService.searchAtestacionRefAtestPin(params).subscribe({
                next: result => {
                    if (result) {
                        let claveSolicitudAtest = new TClaveSolicitudAtestFitoViewModel();
                        claveSolicitudAtest = result;

                        //comprobar que la atestación no esté anulada
                        if (claveSolicitudAtest.IdEstadoSolicitudAtest === EnumIdsTcEstadoSolicitudAtestFito.ID_ANULADA) {
                            this.mensajeAtestacion = 'La Atestación está anulada';
                            this.validacionCollection.push(this.mensajeAtestacion);
                        } else {
                            //comprobar si ya existe el elemento en la colleccion
                            const found = this.atestFitoCollection?.some(item => item.IdSolicitudAtestFito === claveSolicitudAtest.IdSolicitudAtestFito);
                            if (!found) {
                                //comprobar que sólo se añade una atestación 'Con Productos'
                                const conProductos = this.atestFitoCollection?.some(item => !item.SinProductos === !claveSolicitudAtest.SinProductos);
                                if (conProductos) {
                                    this.mensajeAtestacion = 'Sólo se puede añadir una Atestación con productos';
                                    this.validacionCollection.push(this.mensajeAtestacion);
                                } else {
                                    //comprobar la fechaValidez de la atestación
                                    const hoy = new Date();
                                    //se añade un día a la fecha fin para que tenga en cuenta el día completo de validez
                                    const fechaValidezFinMasUno = new Date(claveSolicitudAtest.FechaValidezFin ?? new Date());
                                    fechaValidezFinMasUno.setDate(fechaValidezFinMasUno.getDate() + 1);
                                    if (
                                        claveSolicitudAtest.FechaValidezInicio != null &&
                                        claveSolicitudAtest.FechaValidezFin != null &&
                                        (hoy > fechaValidezFinMasUno || hoy < new Date(claveSolicitudAtest.FechaValidezInicio))
                                    ) {
                                        this.mensajeAtestacion = 'La Fecha de Validez de la Atestación está fuera de plazo';
                                        this.validacionCollection.push(this.mensajeAtestacion);
                                    } else {
                                        //comprobar que el 'PaisDestino' seleccionado coincide con el de la atestación
                                        if (this.IdPaisDestino === claveSolicitudAtest.IdPaisDestino) {
                                            //RDLF-->cambia la forma de introducir elementos al array para que refresque la p-tabla
                                            this.atestFitoCollection = [...this.atestFitoCollection, claveSolicitudAtest];
                                            this.numeroAtestaciones = this.atestFitoCollection?.length;

                                            if (this.numeroAtestaciones > 0) {
                                                this.form.controls['IdPaisDestino'].disable();
                                            }

                                            this.form.patchValue({
                                                RefAtestFito: '',
                                                Pin: '',
                                            });
                                        } else {
                                            this.mensajeAtestacion = 'El País de Destino seleccionado no coincide con el de la Atestación';
                                            this.validacionCollection.push(this.mensajeAtestacion);
                                        }
                                    }
                                }
                            } else {
                                this.mensajeAtestacion = 'Ya se ha añadido';
                            }
                        }
                    } else {
                        this.mensajeAtestacion = 'No se ha encontrado la solicitud de Atestación Fitosanitaria';
                        this.validacionCollection.push(this.mensajeAtestacion);
                    }
                },
                error: error => {
                    this.catchServerError(error);
                },
            });
        }
    }

    onDeleteAtestacion(claveSolicitudAtest: TClaveSolicitudAtestFitoViewModel) {
        //this.solicitudTasasEx.TTasaExCollection.splice(this.solicitudTasasEx.TTasaExCollection.indexOf(tasaEx), 1);
        //RDLF-->cambia la forma de eliminar elementos al array para que refresque la p-tabla
        this.atestFitoCollection = [
            ...this.atestFitoCollection.slice(0, this.atestFitoCollection.indexOf(claveSolicitudAtest)),
            ...this.atestFitoCollection.slice(this.atestFitoCollection.indexOf(claveSolicitudAtest) + 1),
        ];

        this.numeroAtestaciones = this.atestFitoCollection.length;
        if (this.numeroAtestaciones == 0 && this.form.controls['tipoSolicitudEx'].value != 'C') {
            this.form.controls['IdPaisDestino'].enable();
        }
    }

    onSearchSolicitudByCodigo() {
        this.validacionCollection = [];
        this.NumeroCertificado = '';
        this.solicitudEx = new SolicitudExViewModel();
        let anulSustActiva = false;
        this.addValidator('CodigoSolicitud', Validators.required);
        this.addValidator('NumeroCertificado', Validators.required);

        if (this.form.controls['CodigoSolicitud'].value !== '') {
            this.solicitudExService.getSolicitudExByCodigo(this.form.controls['CodigoSolicitud'].value).subscribe({
                next: res => {
                    this.solicitudEx = res;
                    if (res != null) {
                        //llamada a metodo para saber si ya tiene una clonada activa
                        this.solicitudExService.checkAnulSustActiva(this.solicitudEx.Id).subscribe({
                            next: result => {
                                anulSustActiva = result;

                                if (this.solicitudEx.IdUsuarioSolicitante != this.loggedInUser!.Id) {
                                    this.validacionCollection.push('La solicitud es de otro solicitante');
                                } else if (this.solicitudEx.IdEstadoSolicitudEx !== EnumIdsTcEstadoSolicitudEx.ID_FINALIZADA_CONFORME) {
                                    this.validacionCollection.push('La solicitud no está Finalizada Conforme');
                                } else if (this.solicitudEx.NumeroCertificado === null) {
                                    this.validacionCollection.push('No se ha expedido el Certificado Fitosanitario para esta solicitud');
                                }
                                //RDLF: en principio no se permite el tipo Atestación, ya que para liberar los Kg (o la medida que sea) es necesario anular antes la solicitud 'Padre' u original
                                else if (this.solicitudEx.AtestacionFito === true) {
                                    this.validacionCollection.push(
                                        'No es posible hacer Anulación y Sustitución en solicitudes con Atestación. Debe anular el CF y crear una solicitud nueva para continuar',
                                    );
                                } else if (anulSustActiva) {
                                    this.validacionCollection.push('Ya hay una solicitud clonada activa de esta solicitud');
                                } else {
                                    //ELIMINAR LA VALIDACIONES DE COD. SOLICITUD y NUM. CERTIFICADO
                                    this.NumeroCertificado = this.solicitudEx.NumeroCertificado;
                                    this.mensajeExito1 = 'Va a solicitar la anulación del Certificado Fitosanitario Nº ';
                                    this.mensajeExito2 =
                                        ' y su sustitución por un nuevo certificado. Para ello, debe aportar en esta solicitud la documentación oficial en la que se detallen las circunstancias que justifiquen la necesidad de sustituirlo. Además, en la solicitud se deberá adjuntar el certificado fitosanitario de exportación original o documentación oficial del país importador o, en su defecto, otra documentación justificativa suficiente.';

                                    this.removeValidators('CodigoSolicitud');
                                    this.removeValidators('NumeroCertificado');
                                }
                            },
                            error: error => {
                                this.catchServerError(error);
                            },
                        });
                    } else {
                        this.validacionCollection.push('La solicitud no se ha encontrado');
                    }
                },
                error: error => {
                    this.catchServerError(error);
                },
            });
        } else {
            this.validacionCollection.push('Debe añadir un Nº Solicitud válido');
        }
    }

    onSearchSolicitudByNumeroCertificado() {
        this.validacionCollection = [];
        this.NumeroCertificado = '';
        this.solicitudEx = new SolicitudExViewModel();
        let anulSustActiva = false;
        this.addValidator('CodigoSolicitud', Validators.required);
        this.addValidator('NumeroCertificado', Validators.required);

        if (this.form.controls['NumeroCertificado'].value !== '') {
            const parte1Cert: string = this.form.controls['NumeroCertificado'].value.split('/')[0];
            const parte2Cert: string = this.form.controls['NumeroCertificado'].value.split('/')[1];
            const parte2NumeroCert: string | null = parte2Cert != null ? parte2Cert.trim().substr(0, 8) : null;

            if (parte1Cert != null && parte2Cert != null && parte2NumeroCert != null) {
                if (
                    parte1Cert.toUpperCase() != 'UE ES ' ||
                    !parte2Cert.startsWith(' ') ||
                    parte2Cert.trim().length != 9 ||
                    !/^([0-9])*$/.test(parte2NumeroCert!) ||
                    (!parte2Cert.endsWith('B') && !parte2Cert.endsWith('C'))
                ) {
                    this.validacionCollection.push(
                        'Error de formato, el Nº Certificado debe tener esta forma: "UE ES / XXXXXXXXY", siendo "XXXXXXXX" un nº de 8 cifras e "Y" la letra B o C',
                    );
                } else {
                    this.solicitudExService.getSolicitudExByNumeroCertificado(this.form.controls['NumeroCertificado'].value).subscribe({
                        next: res => {
                            this.solicitudEx = res;
                            if (res != null) {
                                //llamada a metodo para saber si ya tiene una clonada activa
                                this.solicitudExService.checkAnulSustActiva(this.solicitudEx.Id).subscribe({
                                    next: result => {
                                        anulSustActiva = result;

                                        if (this.solicitudEx.IdUsuarioSolicitante != this.loggedInUser!.Id) {
                                            this.validacionCollection.push('La solicitud es de otro solicitante');
                                        } else if (this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_FINALIZADA_CONFORME) {
                                            this.validacionCollection.push('La solicitud no está Finalizada Conforme');
                                        } else if (this.solicitudEx.NumeroCertificado === null) {
                                            this.validacionCollection.push('No se ha expedido el Certificado Fitosanitario para esta solicitud');
                                        }
                                        //RDLF: en principio no se permite el tipo Atestación, ya que para liberar los Kg (o la medida que sea) es necesario anular antes la solicitud 'Padre' u original
                                        else if (this.solicitudEx.AtestacionFito === true) {
                                            this.validacionCollection.push(
                                                'No es posible hacer Anulación y Sustitución en solicitudes de tipo Atestación. Debe anular el CF y crear una solicitud nueva para continuar',
                                            );
                                        } else if (anulSustActiva) {
                                            this.validacionCollection.push('Ya hay una solicitud clonada activa de esta solicitud');
                                        } else {
                                            //ELIMINAR LA VALIDACIONES DE COD. SOLICITUD y NUM. CERTIFICADO
                                            this.NumeroCertificado = this.solicitudEx.NumeroCertificado;
                                            this.mensajeExito1 = 'Va a solicitar la anulación del Certificado Fitosanitario Nº ';
                                            this.mensajeExito2 =
                                                ' y su sustitución por un nuevo certificado. Para ello, debe aportar en esta solicitud la documentación oficial en la que se detallen las circunstancias que justifiquen la necesidad de sustituirlo. Además, en la solicitud se deberá adjuntar el certificado fitosanitario de exportación original o documentación oficial del país importador o, en su defecto, otra documentación justificativa suficiente.';

                                            this.removeValidators('CodigoSolicitud');
                                            this.removeValidators('NumeroCertificado');
                                        }
                                    },
                                    error: error => {
                                        this.catchServerError(error);
                                    },
                                });
                            } else {
                                this.validacionCollection.push('La solicitud no se ha encontrado');
                            }
                        },
                        error: error => {
                            this.catchServerError(error);
                        },
                    });
                }
            } else {
                this.validacionCollection.push(
                    'Error de formato, el Nº Certificado debe tener esta forma: "UE ES / XXXXXXXXY", siendo "XXXXXXXX" un nº de 8 cifras e "Y" la letra B o C',
                );
            }
        } else {
            this.validacionCollection.push('Debe añadir un Nº Certificado válido');
        }
    }

    //para activar o no el botón de Aceptar
    get isDisabled(): boolean {
        return this.validacionCollection?.length > 0;
    }

    //Para las solicitudes de ATESTACION FITO
    onSubmit() {
        const solicitudEx = new SolicitudExViewModel();

        //solicitud.Codigo = null;
        solicitudEx.IdTipoSolicitudEx = this.form.controls['tipoSolicitudEx'].value;
        solicitudEx.IdPuntoInspeccion = this.form.controls['IdPuntoInspeccion'].value;
        solicitudEx.EsPrevia = false;
        solicitudEx.TLugarMercanciaEx.IdPaisDestino = this.IdPaisDestino;
        solicitudEx.TLugarMercanciaEx.IdUbicacion = this.form.controls['IdUbicacion'].value;
        solicitudEx.TLugarMercanciaEx.IdInstalacionAutorizada = this.form.controls['IdInstalacionAutorizada'].value;
        solicitudEx.IdIdioma = this.IdIdioma; // this.form.value.IdIdioma;
        solicitudEx.IdUsuarioSolicitante = this.loggedInUser!.Id;
        solicitudEx.ListSolicitudesAtestacionFito = [];

        for (let i = 0; i < this.atestFitoCollection?.length; i++) {
            solicitudEx.ListSolicitudesAtestacionFito.push(this.atestFitoCollection[i].IdSolicitudAtestFito);
        }

        if (this.atestFitoCollection?.length > 0 || solicitudEx.ListSolicitudesAtestacionFito.length > 0) {
            solicitudEx.AtestacionFito = true;

            if (solicitudEx.IdTipoSolicitudEx.toString() === 'R') {
                solicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION;
                solicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
            } else if (solicitudEx.IdTipoSolicitudEx.toString() === 'T') {
                solicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS;
                solicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
            } else if (solicitudEx.IdTipoSolicitudEx.toString() === 'C') {
                solicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_CANARIAS;
                solicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;
            }
        }

        solicitudEx.IdEstadoSolicitudEx = EnumIdsTcEstadoSolicitudEx.ID_BORRADOR;

        solicitudEx.IdFormatoSolicitudEx = EnumIdsTcFormatoSolicitud.ID_APLICACION; //Aplicacion

        this.solicitudExService.createSolicitud(solicitudEx).subscribe({
            next: res => {
                this.addSuccessMessage('Solicitud añadida correctamente');
                const idSolicitud = res;
                this.router.navigate(['/exportacion/solicitud/datosbasicosEx/' + idSolicitud]);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    private WriteParams() {
        this.solicitudExService.currentParamNuevaSolicitudEx = new ParametrosNuevaSolicitudExViewModel();

        switch (this.form.controls['tipoSolicitudEx'].value) {
            case 'T':
                this.solicitudExService.currentParamNuevaSolicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS;
                this.solicitudExService.currentParamNuevaSolicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_SIN_ATEST_FITO;
                break;
            case 'R':
                this.solicitudExService.currentParamNuevaSolicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION;
                this.solicitudExService.currentParamNuevaSolicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_SIN_ATEST_FITO;
                break;
            case 'C':
                this.solicitudExService.currentParamNuevaSolicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_CANARIAS;
                this.solicitudExService.currentParamNuevaSolicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_SIN_ATEST_FITO;
                break;
            case 'CE':
                this.solicitudExService.currentParamNuevaSolicitudEx.IdTipoSolicitudEx = EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS;
                if (this.AvisoConfeccionPeriodo) {
                    this.solicitudExService.currentParamNuevaSolicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_CAMPANIAS_CON_AVISO_CONF;
                } else {
                    this.solicitudExService.currentParamNuevaSolicitudEx.IdSubTipoSolicitudEx = EnumIdsTwTcSubTipoSolicitudEx.ID_CAMPANIAS_SIN_AVISO_CONF;
                }
                break;
        }
        this.solicitudExService.currentParamNuevaSolicitudEx.tipoSolicitudEx = this.form.controls['tipoSolicitudEx'].value;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdPaisDestino = this.IdPaisDestino;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdPuntoInspeccion = this.form.controls['IdPuntoInspeccion'].value;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdUbicacion =
            this.form.controls['IdUbicacion'].value !== null ? this.form.controls['IdUbicacion'].value : null;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdInstalacionAutorizada =
            this.form.controls['IdInstalacionAutorizada'].value !== null ? this.form.controls['IdInstalacionAutorizada'].value : null;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdIdioma = this.IdIdioma; //this.form.value.IdIdioma;
        this.solicitudExService.currentParamNuevaSolicitudEx.esPrevia =
            this.form.controls['esPrevia'].value !== null ? this.form.controls['esPrevia'].value : false;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdCampania = this.form.controls['IdCampania'].value;
        this.solicitudExService.currentParamNuevaSolicitudEx.IdPeriodo = this.form.controls['IdPeriodo'].value;
        this.solicitudExService.currentParamNuevaSolicitudEx.AvisoConfeccion = this.AvisoConfeccionPeriodo;
        this.solicitudExService.currentParamNuevaSolicitudEx.esAtestacionFitosanitaria =
            this.form.controls['esAtestacionFitosanitaria'].value !== null ? this.form.controls['esAtestacionFitosanitaria'].value : false;
        //SET de los parametros de la nueva solicitud para guardarlos en el localStorage
        this.solicitudExService.setParamsSolicitudEx(this.solicitudExService.currentParamNuevaSolicitudEx);
    }

    resetAtestFito() {
        if (this.form.controls['tipoSolicitudEx'].value != 'C') {
            this.form.patchValue({
                IdPaisDestino: null,
            });
        }
        this.listPais = [];
        if (this.form.controls['esAtestacionFitosanitaria'].value === true) {
            this.globalService.getAllPaisesExpor().subscribe(res => {
                this.listPais = res;
            });
            this.mostrarAtestacionesFitosanitarias = true;
            this.form.patchValue({
                esPrevia: false,
            });
            this.form.controls['esPrevia'].disable();
        } else {
            this.globalService.getAllPaisesSinSpain().subscribe(res => {
                this.listPais = res;
            });
            this.mostrarAtestacionesFitosanitarias = false;
            this.form.patchValue({
                RefAtestFito: '',
                Pin: '',
            });
            if (this.form.controls['tipoSolicitudEx'].value === 'T') {
                this.form.controls['esPrevia'].enable();
            }
        }

        if (this.form.controls['esAtestacionFitosanitaria'].value === false && this.atestFitoCollection?.length > 0) {
            this.globalService.getAllPaisesSinSpain().subscribe(res => {
                this.listPais = res;
            });
            this.mostrarAtestacionesFitosanitarias = true;
            this.confirmationService.confirm({
                message: 'Si desactiva el campo "Atestación Fitosanitaria" se eliminarán las atestaciones añadidas. ¿Está seguro?',
                accept: () => {
                    this.mostrarAtestacionesFitosanitarias = false;
                    this.atestFitoCollection = [];
                    this.numeroAtestaciones = this.atestFitoCollection?.length;
                    this.form.controls['IdPaisDestino'].enable();
                },
                reject: () => {
                    this.mostrarAtestacionesFitosanitarias = true;
                    this.form.patchValue({
                        esAtestacionFitosanitaria: true,
                    });
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitudes']);
    }
}
